import { cn } from '@wellesley/ui'
import { FC, useState } from 'react'
import CommonDialog, {
  type CommonDialogProps,
} from 'components/modals/CommonDialog'

type ContentProps = { isOpen: boolean; setOpen(val: boolean): void }

export type MobileBottomModalProps = Pick<
  CommonDialogProps,
  | 'open'
  | 'title'
  | 'className'
  | 'style'
  | 'showClose'
  | 'renderFooter'
  | 'titleClassName'
  | 'footerClassName'
  | 'childrenClassName'
  | 'onCloseModal'
> & {
  testId?: string
  renderContent: (props: ContentProps) => JSX.Element
  renderToggler?: (toggle: () => void, isOpen: boolean) => JSX.Element
}

export const MOBILE_BOTTOM_DIALOG_CLASSNAME =
  'animate-slide-up bottom-0 left-0 right-0 top-[unset] max-w-full transform-none rounded-b-none rounded-t-lg pb-10 max-md:w-full'

const MobileBottomModal: FC<MobileBottomModalProps> = ({
  testId = 'mobile-bottom-modal',
  className,
  renderContent,
  renderToggler,
  showClose = false,
  ...dialogProps
}) => {
  const [isOpen, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
    dialogProps.onCloseModal?.()
  }

  return (
    <>
      {renderToggler && renderToggler(() => setOpen((state) => !state), isOpen)}
      <CommonDialog
        open={isOpen}
        testId={testId}
        showClose={showClose}
        skipModalAutofocus={true}
        onCloseModal={handleClose}
        className={cn(MOBILE_BOTTOM_DIALOG_CLASSNAME, className)}
        {...dialogProps}
      >
        {renderContent({ isOpen, setOpen })}
      </CommonDialog>
    </>
  )
}

export default MobileBottomModal
